module.exports = __webpack_public_path__ + "img/nodeLogo.48e3cf2c.png";